"use strict";

/**
 * @classdesc
 * OL-Implementierung der Geometrie-Bearbeiten-Interaktion.
 *
 * @class
 * @extends gc.gis.module.GCEditGeometry.Impl
 * @memberof gc.gis.module.GCEditGeometry
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {gc.gis.module.GCEditGeometry} options.instance Modul-Instanz
 * @param {gc.gis.map.GCMapView} options.map Karten-Instanz
 */
gc.gis.module.GCEditGeometry.OlImpl = function(options)
{
	gc.gis.module.GCEditGeometry.Impl.call(this, options);
	var self = this;

	/**
	 * @var ol.Map
	 */
	this._ol_map = this.map.getMap().getImpl();

	/**
	 * Der Layer, welcher bearbeitet werden soll.
	 * @type {gc.gis.layer.GCLayer|null}
	 * @protected
	 */
	this._editLayer = null;

	/**
	 * @type {gc.gis.source.OLMapCatalogueVector}
	 * @private
	 */
	this._source = new gc.gis.source.OLMapCatalogueVector(this.map, {
		sourceLayers: [],    // leere Liste zunächst keine Abfrage
		forceMapProjection: true,
		returnWritableOnly: true,
		ignoreSupportFeatureList: true,
		load: function (feature, ol_feature) {
			ol_feature.setProperties({
				geom_orig: ol_feature.getGeometry().clone()
			});
			return true;
		},
		clearExcludes: function () {
			return self.getSelectedFeatures();
		},
		loadMessage: 'Lade Vektordaten für Bearbeitung ...'
	});

	/**
	 * Tracking-Layer welcher die bearbeitbaren Geometrien enthält.
	 * @type {gc.gis.layer.OLTrackingLayer}
	 * @private
	 */
	this._dataLayer = new gc.gis.layer.OLTrackingLayer(this.map.getMap(), {});
	this._dataLayer.setStyle(gc.gis.iface.styleFactory.getStyle(gc.gis.factory.StyleType.TRANSPARENT));
	this._dataLayer.getImpl().setSource(this._source.getSource());

	this._transform_interaction.setLayerFilter(this._dataLayer);
};
gc.gis.module.GCEditGeometry.OlImpl.prototype = Object.create(gc.gis.module.GCEditGeometry.Impl.prototype);


/**
 * @inheritdoc
 */
gc.gis.module.GCEditGeometry.OlImpl.prototype.setEditLayer = function(layer)
{
	if (this._editLayer !== layer)
	{
		this._editLayer = layer;
		this._source.setSourceLayers(!this._editLayer ? [] : [this._editLayer]);
		this._source.refresh();
	}
};

/**
 * @inheritdoc
 */
gc.gis.module.GCEditGeometry.OlImpl.prototype.enableEdit = function(active)
{
	if (active === true)
	{
		this.map.getMap().addTrackingLayer(this._dataLayer);
	}
	else
	{
		this.map.getMap().removeTrackingLayer(this._dataLayer);
	}
	this._transform_interaction.setActive(active === true);
};

/**
 * @inheritdoc
 */
gc.gis.module.GCEditGeometry.OlImpl.prototype.toTransactionServiceFeatures = function(features, ids_only)
{
	ids_only = ids_only === true;

	var serviceFeature,
		serviceFeatures = [],
		uniqueId,
		detail,
		i, ii;

	for (i = 0, ii = features.length; i < ii; i++)
	{
		// Aufbau ID: layername.facID#koordID
		uniqueId = features[i].getID();
		uniqueId = uniqueId.substr(uniqueId.lastIndexOf('.') + 1).split('#');
		if (uniqueId.length === 2)
		{
			serviceFeature = new gc.gis.service.feature.TransactionFachDBFeature();
			serviceFeature.setID(uniqueId[0]);
			detail = {
				ID: uniqueId[1]
			};

			if (!ids_only)
			{
				detail.geometry = features[i].getGeometry();
			}
			serviceFeature.addGeometry(detail);
			serviceFeatures.push(serviceFeature);
		}
		else
		{
			throw new gc.gis.error.GCError('Ungültige Objekt-ID.');
		}
	}

	return serviceFeatures;
};

/**
 * @inheritdoc
 */
gc.gis.module.GCEditGeometry.OlImpl.prototype.editCancel = function(features)
{
	var i, ii;
	for (i = 0, ii = features.length; i < ii; i++)
	{
		this._transform_interaction.unSelectFeature(features[i]);
		features[i].getImpl().setGeometry(features[i].getAttribute('geom_orig').clone());
	}
};

/**
 * @inheritdoc
 */
gc.gis.module.GCEditGeometry.OlImpl.prototype.saveSuccess = function(features)
{
	var i, ii;
	for (i = 0, ii = features.length; i < ii; i++)
	{
		this._transform_interaction.unSelectFeature(features[i]);
		features[i].setAttribute('geom_orig', features[i].getImpl().getGeometry().clone());
	}
};

/**
 * @inheritdoc
 */
gc.gis.module.GCEditGeometry.OlImpl.prototype.saveFailed = function(features)
{
	// now do nothing
};

/**
 * @inheritdoc
 */
gc.gis.module.GCEditGeometry.OlImpl.prototype.deleteSuccess = function(features)
{
	var i, ii;
	for (i = 0, ii = features.length; i < ii; i++)
	{
		this._transform_interaction.unSelectFeature(features[i]);
		this._dataLayer.removeFeature(features[i]);
	}
};

/**
 * @inheritdoc
 */
gc.gis.module.GCEditGeometry.OlImpl.prototype.deleteFailed = function(features)
{
	var i, ii;
	for (i = 0, ii = features.length; i < ii; i++)
	{
		this._transform_interaction.unSelectFeature(features[i]);
	}
};